export default __webpack_public_path__ + "static/media/hero-level-6-chars-mob.0fa5e395.webp";